export default class CatalogFilterOption {
  private readonly _filter: number | number[];
  private readonly _container: HTMLElement;

  constructor(filter: number | number[], element: HTMLElement) {
    this._filter = filter;
    this._container = element;
  }

  get filter(): number | number[] {
    return this._filter;
  }

  get container(): HTMLElement {
    return this._container;
  }

  private _counter: number;

  public set counter(count: number) {
    this._counter = count;
    $(this._container).find(".active-count").text(`(${count})`);
  }

  public SetActive(): void {
    const parent = $(this._container).closest(".dropdown");
    parent.find(".dropdown-text").html($(this._container).html());
    $(this._container).addClass("filter-active");
  }
}
